<template>
  <div class="skeleton-table mx-4 elevation-2 rounded">
    <!-- Header row -->
    <div class="skeleton-header">
      <div class="skeleton-col col-action">
        <div class="skel-block skel-checkbox" />
      </div>
      <div class="skeleton-col col-name">
        <div class="skel-block skel-label" style="width:60%" />
      </div>
      <div class="skeleton-col col-md" v-for="i in 4" :key="`h${i}`">
        <div class="skel-block skel-label" :style="`width:${50 + i * 8}%`" />
      </div>
      <div class="skeleton-col col-sm" v-for="i in 3" :key="`hs${i}`">
        <div class="skel-block skel-label" :style="`width:${45 + i * 10}%`" />
      </div>
    </div>

    <!-- Data rows -->
    <div
      v-for="r in 10"
      :key="r"
      class="skeleton-row"
      :class="r % 2 === 0 ? 'skeleton-row--even' : ''"
    >
      <!-- Checkbox + action -->
      <div class="skeleton-col col-action">
        <div class="skel-block skel-checkbox shimmer" />
        <div class="skel-block skel-btn shimmer" style="margin-left:8px" />
      </div>

      <!-- Name + date (two lines) -->
      <div class="skeleton-col col-name">
        <div
          class="skel-block shimmer"
          :style="
            `width:${55 + ((r * 13) % 30)}%; height:10px; margin-bottom:6px`
          "
        />
        <div
          class="skel-block shimmer"
          :style="`width:${40 + ((r * 7) % 25)}%; height:13px`"
        />
      </div>

      <!-- Phone -->
      <div class="skeleton-col col-md">
        <div
          class="skel-block shimmer"
          :style="`width:${65 + ((r * 5) % 25)}%; height:12px`"
        />
      </div>

      <!-- Email -->
      <div class="skeleton-col col-md">
        <div
          class="skel-block shimmer"
          :style="`width:${50 + ((r * 11) % 35)}%; height:12px`"
        />
      </div>

      <!-- Phase chip -->
      <div class="skeleton-col col-md">
        <div
          class="skel-block skel-chip shimmer"
          :style="`width:${50 + ((r * 9) % 30)}%`"
        />
      </div>

      <!-- Budget -->
      <div class="skeleton-col col-md">
        <div
          class="skel-block shimmer"
          :style="
            `width:${40 + ((r * 7) % 30)}%; height:12px; margin-left:auto`
          "
        />
      </div>

      <!-- Source -->
      <div class="skeleton-col col-sm d-flex align-center">
        <div class="skel-block skel-avatar shimmer" />
        <div
          class="skel-block shimmer"
          style="width:45%; height:11px; margin-left:6px"
        />
      </div>

      <!-- Broker -->
      <div class="skeleton-col col-sm">
        <div
          class="skel-block shimmer"
          :style="`width:${50 + ((r * 6) % 30)}%; height:12px`"
        />
      </div>

      <!-- Tags -->
      <div class="skeleton-col col-sm d-flex" style="gap:4px">
        <div class="skel-block skel-tag shimmer" />
        <div
          v-if="r % 3 !== 0"
          class="skel-block skel-tag shimmer"
          style="width:20px"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "SkeletonTableLead" };
</script>

<style scoped>
.skeleton-table {
  background: #fff;
  overflow: hidden;
}

/* Header */
.skeleton-header {
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 48px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

/* Rows */
.skeleton-row {
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 52px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}
.skeleton-row--even {
  background: rgba(204, 204, 204, 0.08);
}

/* Columns */
.skeleton-col {
  display: flex;
  align-items: center;
  padding: 0 6px;
  flex-shrink: 0;
}
.col-action {
  width: 90px;
}
.col-name {
  flex: 2;
  flex-direction: column;
  align-items: flex-start;
}
.col-md {
  flex: 1.5;
}
.col-sm {
  flex: 1;
}

/* Block base */
.skel-block {
  border-radius: 4px;
  background: #e0e0e0;
  height: 12px;
  width: 100%;
}
.skel-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}
.skel-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}
.skel-chip {
  height: 22px;
  border-radius: 11px;
}
.skel-tag {
  width: 28px;
  height: 20px;
  border-radius: 10px;
}
.skel-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
}
.skel-label {
  height: 10px;
  border-radius: 3px;
  background: #d0d0d0;
}

/* Shimmer animation */
@keyframes shimmer {
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
}
.shimmer {
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 1200px 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}
</style>
